import React from 'react';
import SidebarComponents from '../components/sidebar.components';

export default function SidebarContainer() {
  return <SidebarComponents />;
}
